import React from "react"
import Navi from "./Navi"


export default function Home()
{
    return (
        <Navi />
    );
}


